import React from 'react';

// Parses **bold** markers into <b> elements
export const parseBold = (text: string): React.ReactElement => {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return (
    <>
      {parts.map((part, i) =>
        part.startsWith('**') && part.endsWith('**') ? (
          <b key={i}>{part.slice(2, -2)}</b>
        ) : (
          part
        )
      )}
    </>
  );
};
